// extracted by mini-css-extract-plugin
export default {"container":"Slider-module__container-xFFWYw","bottomNavigation":"Slider-module__bottomNavigation-oh8aip","fullWidth":"Slider-module__fullWidth-evA9Q3"};